import { Box, styled, Tab, Tabs } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  boxSizing: 'border-box',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '12px',
  padding: '1rem',
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
}));

const TabPanel = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(0.5),
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 36,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    gap: 0,
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  flex: 1,
  minHeight: 36,
  maxWidth: 'none',
  padding: theme.spacing(0.75, 1.5),
  fontSize: '0.8125rem',
  fontWeight: 500,
  textTransform: 'none',
  color: theme.palette.text.secondary,
  borderRight: `1px solid ${theme.palette.divider}`,
  '&.Mui-selected': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  '&:last-of-type': {
    borderRight: 'none',
  },
}));

export { Container, TabPanel, StyledTabs, StyledTab };
